// var swiper = new Swiper(".mySwiper", {
//   zoom: true,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
// });

/**
 * Posts swiper
 */

function x_swiper_init(instance) {

  const grid = parseInt(instance.getAttribute('data-grid'));
  console.log("Gridi " + grid);
  const spaceBetween = 24;
  const breakpoints = {
    0: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 1,
    }
  };

  if (grid >= 2) {
    Object.assign(breakpoints, {
      600: {
        slidesPerView:2,
      },
      850: {
        slidesPerView: 2,
      }
    });
  }

  if (grid >= 3) {
    Object.assign(breakpoints, {
      850: {
        slidesPerView: 3,
      },
      1100: {
        slidesPerView: 3,
      }
    });
  }

  if (grid >= 4) {
    Object.assign(breakpoints, {
      1100: {
        slidesPerView: 4,
      },
      1250: {
        slidesPerView: 4,
      }
    });
  }

  if (grid >= 5) {
    Object.assign(breakpoints, {
      1250: {
        slidesPerView: 5,
      },
      1440: {
        slidesPerView: 5,
      }
    });
  }

  if (grid >= 6) {
    Object.assign(breakpoints, {
      1: {
        slidesPerView: 6,
      },
      1440: {
        slidesPerView: 6,
      }
    });
  }

  if (grid >= 7) {
    Object.assign(breakpoints, {
      1: {
        slidesPerView: 2,
        centeredSlides: true,
      },
      600: {
        slidesPerView: 4,
      },
      1440: {
        slidesPerView: 7,
      }
    });
  }

  const swiper = new Swiper(instance, {
    direction: 'horizontal',
    loop: true,
    spaceBetween: spaceBetween,
    noSwiping: false,
    observer: true,
    resizeReInit: true,
    breakpoints: breakpoints,
    slideToClickedSlide: false,
    watchOverflow: true,
    focusableElements: 'article',
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    // If we need pagination
    pagination: {
      el: instance.querySelector('.swiper-pagination'),
    },

    // Navigation arrows
    navigation: {
      nextEl: instance.querySelector('.swiper-button-next'),
      prevEl: instance.querySelector('.swiper-button-prev'),
    },

    // And if we need scrollbar
    scrollbar: {
      el: instance.querySelector('.swiper-scrollbar'),
    }
  });

  window.addEventListener("resize", function(){
    setTimeout(function () {

      swiper.slideReset();
      swiper.update();
      swiper.detachEvents();
      swiper.attachEvents();


      // swiper.reInit();

    }, 1000);
  });

};

function x_swiper() {
  const swiper = document.querySelectorAll('.js-swiper-container');

  for (let i = 0; i < swiper.length; i++) {
    x_swiper_init(swiper[i]);
  }
};

x_swiper();

